export interface Dica {
  texto: string
  modulo: string
  icone: string
}

export const DICAS_DE_OURO: Dica[] = [
  {
    icone: '💡',
    modulo: 'Terreno',
    texto: 'Verifique a matrícula do terreno e certidões negativas antes de qualquer negociação.',
  },
  {
    icone: '📐',
    modulo: 'Projetos',
    texto: 'Contrate um arquiteto registrado no CAU. O projeto legal é obrigatório para o alvará.',
  },
  {
    icone: '💰',
    modulo: 'Financeiro',
    texto: 'Reserve 10–15% do orçamento como contingência. Imprevistos são a regra, não a exceção.',
  },
  {
    icone: '👷',
    modulo: 'Mão de Obra',
    texto: 'Defina claramente o escopo de cada empreiteiro em contrato antes de iniciar.',
  },
  {
    icone: '🧱',
    modulo: 'Construtivo',
    texto:
      'Compare alvenaria convencional, estrutural e drywall antes de decidir o sistema construtivo.',
  },
  {
    icone: '⚙️',
    modulo: 'Execução',
    texto:
      'Cure o concreto por pelo menos 7 dias. Nunca acelere esse processo para economizar tempo.',
  },
  {
    icone: '📋',
    modulo: 'Tributos',
    texto:
      'Emita nota fiscal de todos os serviços. Isso protege você em eventuais disputas trabalhistas.',
  },
  {
    icone: '💡',
    modulo: 'Terreno',
    texto:
      'Faça um laudo geotécnico antes de definir o tipo de fundação. Economiza tempo e dinheiro.',
  },
  {
    icone: '💰',
    modulo: 'Financeiro',
    texto: 'Mantenha um diário de obra com fotos diárias. Isso protege você de fraudes e desvios.',
  },
  {
    icone: '👷',
    modulo: 'Mão de Obra',
    texto: 'Peça referências e visite obras anteriores antes de contratar qualquer empreiteiro.',
  },
  {
    icone: '📐',
    modulo: 'Projetos',
    texto:
      'Conclua todos os projetos complementares antes de iniciar a obra. Mudanças no meio custam caro.',
  },
  {
    icone: '⚙️',
    modulo: 'Execução',
    texto:
      'Impermeabilize todas as áreas molhadas. É muito mais barato prevenir do que reparar infiltrações.',
  },
  {
    icone: '🧱',
    modulo: 'Construtivo',
    texto:
      'Especifique materiais com antecedência. Substituições emergenciais custam até 30% mais.',
  },
  {
    icone: '📋',
    modulo: 'Tributos',
    texto:
      'O INSS obra pode ser recolhido mensalmente. Acumule dívidas e as multas dobram o custo.',
  },
  {
    icone: '💡',
    modulo: 'Geral',
    texto: 'Visite a obra a cada semana no mínimo. Presença frequente reduz desperdícios e erros.',
  },
]

export function getDicaDoDia(): Dica {
  const start = new Date(new Date().getFullYear(), 0, 0)
  const dayOfYear = Math.floor((Date.now() - start.getTime()) / 86_400_000)
  return DICAS_DE_OURO[dayOfYear % DICAS_DE_OURO.length]!
}
